import { MaskService } from 'react-native-masked-text'
import libPhoneNumber from 'libphonenumber-js'
import moment from 'moment'
import numbro from 'numbro'

/**
 * Phone Mask without Country Code.
 * @param number { number | string }
 * @param silent { boolean} - Return Empty if invalid number
 * @param defaultCountry { string }
 * @returns {string}
 */
export const phoneMask = (
  number = '',
  { silent, defaultCountry } = { silent: true, defaultCountry: 'US' },
) => {
  /*
    Infinite loop otherwise in MaskService.
   */
  let _number = number

  if (typeof number === 'number') _number = number.toString()

  if (_number.length < 10) {
    if (!silent) throw new Error('Invalid Phone Number.')
    return _number
  }

  return libPhoneNumber(_number, defaultCountry).formatNational()
}

export const phoneMaskWithUSCode = (number) =>
  MaskService.toMask('custom', number || '', { mask: '+1 (999) 999-9999' })

export const phoneMaskWithoutCode = (number) =>
  MaskService.toMask('custom', number?.substring(2) || '', {
    mask: '(999) 999-9999',
  })

export const currencyMask = (money = 0, defaultValue = 0) => {
  let amount = typeof money === 'string' ? money.replace(/[^-\d.]/g, '') : money

  if (!amount) {
    amount = defaultValue
  }
  return numbro(amount).formatCurrency({ thousandSeparated: true, mantissa: 2 })
}

export const dateMask = (date) => moment(date).format('MM/DD/YYYY')
